<template>
  <div style="width: 100%" class="search-container">
    <div class="search" style="padding-top: 150px">
      <div class="search-tabs">
        <div
          :class="['search-tab', { active: index === 1 }]"
          @click="changeActive(1)"
        >
          {{ $i18n.t("molecule") }}
        </div>
        <div
          :class="['search-tab', { active: index === 2 }]"
          @click="changeActive(2)"
        >
          {{ $i18n.t("crystal") }}
        </div>
        <div
          :class="['search-tab', { active: index === 3 }]"
          @click="changeActive(3)"
        >
          {{ $i18n.t("chemical_reaction") }}
        </div>
      </div>
      <div class="search-simple-wrapper d-flex mb-n5">
        <input
          v-model.trim="simpleCondition"
          :disabled="index === 3"
          class="searchInput"
          placeholder="请输入查询元素"
          style="
            flex-grow: 1;
            height: 56px;
            outline: none;
            padding: 0 20px;
            border-radius: 10px 0 0 10px;
          "
        />

        <button
          @click="allSearch"
          class="simple-button common-button"
          style="background: #3f57bb; font-size: 18px; outline: none"
        >
          {{ $i18n.t("search") }}
        </button>
      </div>

      <v-row class="search-advanced-tabs">
        <v-col class="d-flex" v-if="index === 1">
          <div
            @click="changeAdvActive(1)"
            :class="[{ advanceActive: advanceActive === 1 }, 'adv-search-tab']"
          >
            <div class="second-menu">
              {{ $i18n.t("advanced_search") }}
            </div>
            <span
              :class="[{ 'icon-active': advanceActive === 1 }, 'icon-wrapper']"
            >
              <v-icon>mdi-chevron-down</v-icon>
            </span>
          </div>
          <div
            @click="changeAdvActive(2)"
            :class="[{ advanceActive: advanceActive === 2 }, 'adv-search-tab']"
          >
            <div class="second-menu">
              {{ $i18n.t("similarity_search") }}
            </div>
            <span
              :class="[{ 'icon-active': advanceActive === 2 }, 'icon-wrapper']"
            >
              <v-icon>mdi-chevron-down</v-icon>
            </span>
          </div>
        </v-col>
        <v-col v-if="index === 2">
          <div
            @click="changeAdvActive(3)"
            :class="[{ advanceActive: advanceActive === 3 }, 'adv-search-tab']"
          >
            <div class="second-title">
              {{ $i18n.t("advanced_search") }}
            </div>
            <span
              :class="[{ 'icon-active': advanceActive === 3 }, 'icon-wrapper']"
            >
              <v-icon>mdi-chevron-down</v-icon>
            </span>
          </div>
        </v-col>
        <v-col v-if="index === 3">
          <div
            @click="changeAdvActive(4)"
            :class="[{ advanceActive: advanceActive === 4 }, 'adv-search-tab']"
          >
            <div class="second-title">
              {{ $i18n.t("advanced_search") }}
            </div>
            <span
              :class="[{ 'icon-active': advanceActive === 4 }, 'icon-wrapper']"
            >
              <v-icon>mdi-chevron-down</v-icon>
            </span>
          </div>
        </v-col>
      </v-row>
      <v-row class="search-advanced-conditions">
        <v-col
          v-if="advanceActive === 1"
          class="advanced-condition advanced-conditions-tab1-1"
          col="12"
        >
          <v-row
            class="advanced-molecule justify-start align-start"
            style="flex: 0"
          >
            <v-col
              sm="12"
              md="6"
              class="advanced-molecule-item d-flex justify-start align-center"
              v-for="(condition, index) in moleConditions"
              :key="index"
            >
              <v-select
                v-model="condition.label"
                :items="moleSystem"
                outlined
                class="inner-select"
                style="width: 160px"
              >
              </v-select>
              <v-text-field
                class="px-2"
                style="width: 80px"
                outlined
                v-model.trim="condition.value"
              >
              </v-text-field>
              <v-select
                class="inner-select"
                :items="types"
                style="max-width: 90px; min-width: 90px"
                v-model="condition.type"
                outlined
                v-if="
                  (moleConditions.length > 1 || index !== 0) &&
                  index !== moleConditions.length - 1
                "
              >
              </v-select>
              <div
                v-if="moleConditions.length > 1"
                class="common-font-color"
                style="margin-bottom: 30px; margin-left: 10px; width: 40px"
                @click="deleteCondition(index)"
              >
                {{ $i18n.t("delete") }}
              </div>
            </v-col>
          </v-row>

          <v-row class="flex-grow-0">
            <v-col cols="12" class="d-flex justify-space-between">
              <div class="d-flex" @click="addConditon">
                <div style="padding: 3px 5px 5px 0; cursor: pointer">
                  <v-icon color="#3f57bb">mdi-plus-box</v-icon>
                </div>
                <div class="common-font-color" style="padding: 5px 5px 5px 0">
                  {{ $i18n.t("add_query_criteria") }}
                </div>
              </div>
              <v-btn
                @click="clearAll('mole')"
                color="#3f57bb"
                height="32px"
                outlined
                width="64px"
              >
                {{ $i18n.t("empty") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="advanceActive === 2" class="pa-0">
          <iframe
            id="first-ketcher"
            style="width: 100%; height: 545px"
            frameborder="0"
            ref="firstIframe"
            src="./ketcher/ketcher.html"
          >
          </iframe>
        </v-col>
        <v-col
          v-if="advanceActive === 3"
          class="advanced-condition advanced-conditions-tab2-1"
          cols="12"
        >
          <v-row>
            <v-col cols="12" class="d-flex" style="height: 56px">
              <div
                class="mr-1 common-font-black-bold"
                style="min-width: 90px; margin-top: 10px; margin-right: 10px"
              >
                {{ $i18n.t("crystal") }}
              </div>

              <CrystalSelector
                :show-index="4"
                :label="label.CRYSTAL_SYSTEM"
                :items="crystalSystems"
                v-model="crystalChips"
                tabIndex="0"
              >
              </CrystalSelector>
            </v-col>
            <v-col cols="12" class="d-flex" style="height: 56px">
              <div
                class="mr-1 common-font-black-bold"
                style="margin-top: 10px; min-width: 90px"
              >
                {{ $i18n.t("label.SPACE_GROUP") }}
              </div>
              <CrystalSelector
                :show-index="7"
                :label="label.SPACE_GROUP"
                :items="spaceGroups"
                v-model="spaceChips"
                tabIndex="0"
              >
              </CrystalSelector>
            </v-col>
            <v-col
              cols="12"
              class="d-flex"
              style="height: 56px; padding-right: 117px"
            >
              <div
                class="mr-1 common-font-black-bold"
                style="margin-top: 10px; min-width: 90px"
              >
                {{ $i18n.t("mol_weight") }}
              </div>
              <v-text-field v-model="moleWeight" outlined></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">{{ $i18n.t("label.UNIT_CELL") }}:</v-col>
            <v-col
              cols="12"
              sm="12"
              md="6"
              class="d-flex py-0"
              v-for="(condition, index) in crystalConditions"
              :key="condition.model + index"
            >
              <div style="margin-top: 8px; margin-left: 70px">
                {{ $i18n.t(condition.model) }} :
              </div>
              <v-text-field
                class="px-2"
                style="max-width: 120px"
                :placeholder="$i18n.t('hint.MIN')"
                outlined
                v-model.trim="condition.min"
              >
              </v-text-field>
              <div style="margin-top: 8px">--</div>
              <v-text-field
                class="px-2"
                style="max-width: 120px"
                :placeholder="$i18n.t('hint.MAX')"
                outlined
                v-model.trim="condition.max"
              >
              </v-text-field>
            </v-col>

            <v-col cols="12 " class="d-flex">
              <v-spacer></v-spacer>
              <v-btn @click="clearAll('cry')" outlined color="#3f57bb">{{
                $i18n.t("empty")
              }}</v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="advanceActive === 4" class="pa-0">
          <iframe
            id="second-ketcher"
            style="width: 100%; height: 545px"
            frameborder="0"
            ref="secondIframe"
            src="./ketcher/ketcher.html"
          >
          </iframe>
        </v-col>
      </v-row>
    </div>
    <div style="width: 100%; font-size: 12px" class="d-flex justify-center">
      <p>Copyright2018 合肥机数量子科技有限公司 All Rights Reserved</p>
      <a
        target="_blank"
        href="https://beian.miit.gov.cn"
        style="
          display: inline-block;
          text-decoration: none;
          height: 20px;
          line-height: 20px;
          color: #999999;
        "
      >
        <p class="mx-10">皖ICP备18011438号-1</p>
      </a>
      <p>
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34011102001180"
          style="
            display: inline-block;
            text-decoration: none;
            height: 20px;
            line-height: 20px;
          "
        >
          <img src="../assets/beian.png" style="float: left" />
          <p
            style="
              float: left;
              height: 20px;
              line-height: 20px;
              margin: 0px 0px 0px 5px;
              color: #939393;
            "
          >
            皖公网安备 34011102001180号
          </p>
        </a>
      </p>
    </div>
  </div>
</template>

<script>
import CrystalSelector from "../components/CrystalSelector";
import * as CrystalSystem from "../utils/crystalsystem";
import * as CellArgements from "../utils/spacegroups";
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "home",
  components: {
    CrystalSelector,
  },
  data() {
    return {
      simpleCondition: "",
      moleWeight: "",
      index: 1,
      advanceActive: "",
      moleConditions: [{ label: "", value: "", type: "or" }],
      crystalConditions: [
        { model: "label.A", min: "", max: "" },
        { model: "label.ALPHA", min: "", max: "" },
        { model: "label.B", min: "", max: "" },
        { model: "label.BETA", min: "", max: "" },
        { model: "label.C", min: "", max: "" },
        { model: "label.GAMMA", min: "", max: "" },
      ],
      items: [],
      types: ["or", "and", "not"],
      crystalChips: [],
      spaceChips: [],
      spaceQueryList: [],
    };
  },
  mounted() {
    document.onkeyup = (e) => {
      if (e.key === "Enter") {
        if (this.showSignIn || this.showSignUp) {
          // pass
        } else {
          this.allSearch();
        }
      }
    };
  },
  computed: {
    ...mapState(["listWhat", "isSignIn", "showSignIn", "showSignUp"]),
    moleSystem() {
      return [
        { text: this.$i18n.t("complexity"), value: "complexity" },
        { text: this.$i18n.t("dasc"), value: "dasc" },
        { text: this.$i18n.t("em"), value: "em" },
        { text: this.$i18n.t("mm"), value: "mm" },
        { text: this.$i18n.t("tpsa"), value: "tpsa" },
        { text: this.$i18n.t("fc"), value: "fc" },
        { text: this.$i18n.t("uasc"), value: "uasc" },
        { text: this.$i18n.t("hbdc"), value: "hbdc" },
        { text: this.$i18n.t("iac"), value: "iac" },
        { text: this.$i18n.t("rbc"), value: "rbc" },
        { text: this.$i18n.t("mw"), value: "mw" },
        { text: this.$i18n.t("dbsc"), value: "dbsc" },
        { text: this.$i18n.t("ubsc"), value: "ubsc" },
        { text: this.$i18n.t("hac"), value: "hac" },
        { text: this.$i18n.t("cbuc"), value: "cbuc" },
        { text: this.$i18n.t("hbac"), value: "hbac" },
        { text: this.$i18n.t("xlogp3"), value: "xlogp3" },
      ];
    },
    label() {
      return {
        CRYSTAL_SYSTEM: this.$i18n.t("label.CRYSTAL_SYSTEM"),
        SPACE_GROUP: this.$i18n.t("label.SPACE_GROUP"),
        UNIT_CELL: this.$i18n.t("label.UNIT_CELL"),
        A: this.$i18n.t("label.A"),
        B: this.$i18n.t("label.B"),
        C: this.$i18n.t("label.C"),
        ALPHA: this.$i18n.t("label.ALPHA"),
        BETA: this.$i18n.t("label.BETA"),
        GAMMA: this.$i18n.t("label.GAMMA"),
      };
    },
    crystalSystems() {
      let system = [
        CrystalSystem.MONOCLINIC, //单斜
        CrystalSystem.ORTHORHOMBIC, // 正交
        CrystalSystem.TRIGONAL,
        CrystalSystem.CUBIC,
        CrystalSystem.TRICLINIC,
        CrystalSystem.TETRAGONAL,
        CrystalSystem.HEXAGONAL,
      ];
      let _i18n = this.$i18n;
      let arr = system.map((x) => {
        return {
          text: _i18n.t(x.text),
          value: x.value,
        };
      });
      return arr;
    },
    spaceGroups() {
      let arr = [];
      this.crystalChips.forEach((x) => {
        CellArgements.CRYSTAL_SYSTEM_TO_SPACE_GROUP[x].forEach((x) => {
          arr.push({
            text: CellArgements.SPACE_GROUP_NUM_SHORT_NAME[x],
            value: x,
          });
        });
      });
      return arr;
    },
  },
  methods: {
    ...mapMutations(["SET_LISTWHAT", "SET_SNACK_INFO", "SET_SIGN_IN"]),
    ...mapActions([
      "molSearch",
      "crystalSearch",
      "getDetail",
      "reactionSearch",
      "signOut",
    ]),
    changeActive(index) {
      if (this.index !== index) {
        this.advanceActive = "";
        this.simpleCondition = "";
        this.index = index;
        if (this.index === 3) {
          this.advanceActive = 4;
        }
      }
    },
    changeAdvActive(index) {
      if (index === this.advanceActive) {
        this.advanceActive = "";
        return;
      }
      this.advanceActive = index;
    },
    allSearch() {
      // mol 查询
      let token = window.localStorage.getItem("accessToken");
      let isSignIn = window.localStorage.getItem("isSignIn");
      if (!(JSON.parse(isSignIn) && JSON.parse(token))) {
        this.SET_SNACK_INFO({
          status: true,
          color: "error",
          msg: "Please log in and use it",
          timeout: 4000,
        });
        this.SET_SIGN_IN(false);
        return;
      } else {
        this.SET_SIGN_IN(true);
      }
      if (this.index === 1) {
        let data = [];
        if (this.advanceActive === "") {
          if (this.simpleCondition) {
            data = [{ type: "title", label: this.simpleCondition }];
          }
        } else if (this.advanceActive === 1) {
          data = this.simpleCondition
            ? [{ type: "title", label: this.simpleCondition }]
            : this.getNoRepeatArr();
        } else if (this.advanceActive === 2) {
          let firstIframe = this.$refs.firstIframe;
          let ketcher = firstIframe.contentWindow.ketcher;
          let smiles = ketcher.getSmiles();
          if (smiles) {
            data = [{ type: "similar", label: smiles }];
          }
        }
        this.SET_LISTWHAT("mole");

        if (data.length !== 0) {
          window.localStorage.setItem("moleConditions", JSON.stringify(data));
          window.open("#/listview/mole");
        }
      }

      if (this.index === 2) {
        let system = [
          "MONOCLINIC",
          "ORTHORHOMBIC",
          "TRIGONAL",
          "CUBIC",
          "TRICLINIC",
          "TETRAGONAL",
          "HEXAGONAL",
        ];
        let crystal_system = [];
        this.crystalChips.forEach((item) => {
          crystal_system.push(system[item]);
        });
        let space_group = [];
        this.spaceQueryList.forEach((item) => {
          let newItem = item
            .replace(new RegExp("<sub>", "gm"), "")
            .replace(new RegExp("</sub>", "gm"), "")
            .replace(
              new RegExp('<span style="text-decoration:overline;">', "gm"),
              ""
            )
            .replace(new RegExp("</span>", "gm"), "");
          space_group.push(newItem);
        });
        let mwArr = [];
        if (this.moleWeight.indexOf("-") !== -1) {
          mwArr.push(this.moleWeight.split("-")[0] - 0);
          mwArr.push(this.moleWeight.split("-")[1] - 0);
        } else {
          mwArr = [
            parseInt(this.moleWeight) - 0.5 || "",
            parseInt(this.moleWeight) + 0.4 || "",
          ];
        }
        let crystalData = {
          type: "advance",
          label: "",
          a: [this.crystalConditions[0].min, this.crystalConditions[0].max],
          b: [this.crystalConditions[2].min, this.crystalConditions[2].max],
          c: [this.crystalConditions[4].min, this.crystalConditions[4].max],
          alpha: [this.crystalConditions[1].min, this.crystalConditions[1].max],
          beta: [this.crystalConditions[3].min, this.crystalConditions[3].max],
          gamma: [this.crystalConditions[5].min, this.crystalConditions[5].max],
          crystal_system: crystal_system,
          space_group: space_group,
          formula_weight: mwArr,
        };

        if (this.simpleCondition !== "") {
          crystalData = {
            type: "title",
            label: this.simpleCondition,
            a: ["", ""],
            b: ["", ""],
            c: ["", ""],
            alpha: ["", ""],
            beta: ["", ""],
            gamma: ["", ""],
            crystal_system: [],
            space_group: [],
            formula_weight: ["", ""],
          };
        }
        this.SET_LISTWHAT("crystal");
        if (crystalData.type === "title" && crystalData.label) {
          window.localStorage.setItem(
            "crystalConditions",
            JSON.stringify(crystalData)
          );
          window.open("#/listview/crystal");
        } else if (
          crystalData.crystal_system.length ||
          crystalData.formula_weight
        ) {
          window.localStorage.setItem(
            "crystalConditions",
            JSON.stringify(crystalData)
          );
          window.open("#/listview/crystal");
        }
      }

      if (this.index === 3 && this.advanceActive === 4) {
        let secondIframe = this.$refs.secondIframe;
        let ketcher = secondIframe.contentWindow.ketcher;
        let smiles = ketcher.getSmiles();
        if (smiles) {
          window.localStorage.setItem(
            "reactionConditions",
            JSON.stringify({ smiles: smiles })
          );
          window.open("#/reaction_list");
        }
      }
    },
    getNoRepeatArr() {
      let arr = [];
      let searchMol = [];
      for (let i = 0; i < this.moleConditions.length; i++) {
        let obj = {
          label: this.moleConditions[i].label,
          min: this.moleConditions[i].value,
          max: this.moleConditions[i].value,
          type: this.changeType(this.moleConditions[i].type),
        };
        if (this.moleConditions[i].value.indexOf("-") !== -1) {
          let arr = this.moleConditions[i].value.split("-");
          obj.min = arr[0] - 0;
          obj.max = arr[1] - 0;
        }
        if (obj.min && obj.max) {
          searchMol.push(obj);
        }
      }
      let newArr = [];
      for (let i = 0; i < searchMol.length; i++) {
        if (arr.indexOf(searchMol[i].label) === -1 && searchMol[i].label) {
          arr.push(searchMol[i].label);
          newArr.push(searchMol[i]);
        }
      }
      return newArr;
    },
    changeType(str) {
      switch (str) {
        case "or":
          return "should";
        case "and":
          return "must";
        case "not":
          return "must_not";
        default:
          return "must";
      }
    },
    addConditon() {
      if (this.moleConditions.length < 10) {
        this.moleConditions.push({ label: "", value: "", type: "and" });
      }
    },
    deleteCondition(index) {
      this.moleConditions.splice(index, 1);
    },
    clearAll(type) {
      if (type === "mole") {
        this.moleConditions = [];
      } else if (type === "cry") {
        this.crystalChips = [];
        this.spaceChips = [];
        this.moleWeight = "";
        this.crystalConditions.forEach((item) => {
          item.min = "";
          item.max = "";
        });
      }
    },
  },
  watch: {
    crystalChips: {
      handler() {
        this.spaceChips = [];
      },
      deep: true,
    },
    spaceChips: {
      handler(newV) {
        let spaceList = this.spaceGroups;
        this.spaceQueryList = [];
        newV.forEach((item) => {
          this.spaceQueryList.push(spaceList[item].text);
        });
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.search-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  .searchInput {
    border: 2px solid #999999;
    border-right: transparent;
  }
  .searchInput:focus {
    border: 2px solid #3f57bb;
    border-right: transparent;
  }
  .v-select__slot {
    height: 40px;
  }

  .search {
    max-width: 1000px;
    min-width: 800px;
    width: 100%;
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex-grow: 1;

    .search-tabs {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 20px;

      .search-tab {
        position: relative;
        height: 24px;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        margin-right: 60px;
        cursor: pointer;
      }

      .search-tab.active {
        color: #3f57bb;
      }

      .search-tab.active::after {
        content: "";
        display: block;
        width: 100%;
        height: 4px;
        background: rgba(68, 98, 247, 1);
        border-radius: 2px;
        position: absolute;
        top: 30px;
        left: 0;
        animation: tab-in 0.5s both;
        animation-direction: alternate;
      }
    }

    .search-simple-wrapper {
      .simple-button {
        border-radius: 0 10px 10px 0;
        height: 56px;
        width: 120px;
      }

      .v-input__slot {
        border-radius: 5px 0 0 5px !important;
      }
    }

    .search-advanced-tabs {
      flex-grow: 0;

      .adv-search-tab {
        width: 200px;
        cursor: pointer;
        display: flex;

        div.second-menu {
          flex-shrink: 0;
        }

        span {
          color: #3f57bb;
          display: inline-block;
          transform: rotate(0deg);
          width: 24px;
          height: 24px;
          border-radius: 50%;
          transition: all 0.5s;
        }

        span.icon-active {
          transform: rotate(180deg);

          .v-icon {
            color: #3f57bb;
          }
        }
      }

      .advanceActive {
        display: flex;
        color: #3f57bb;
      }
    }

    .search-advanced-conditions {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      margin: 2px;
      animation: show-conditions;

      .advanced-condition {
        /*animation: show-conditions .5s;*/
        background-color: white;

        .v-input__slot {
          min-height: 40px !important;
        }

        .v-text-field--rounded > .v-input__control > .v-input__slot {
          padding: 0 12px !important;
        }
        .v-select__selections {
          padding: 0 !important;
        }

        .v-input__append-inner {
          margin-top: 8px !important;
          padding-left: 0 !important;
        }
      }

      .advanced-conditions-tab1-1 {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background-color: white;

        .advanced-molecule {
          &-item {
            padding-top: 0;
            padding-bottom: 0;
          }
        }
      }
    }
  }
}

@keyframes show-conditions {
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes tab-in {
  from {
    width: 10%;
    left: 50%;
  }
  to {
    width: 100%;
    left: 0;
  }
}
</style>
